import { useState } from 'react';

import { Button } from '@/components/Button/Button';

import { IOSInstallInstructions } from './IOSInstallInstructions';
import { useInstallPrompt } from './useInstallPrompt';
import { useStandaloneMode } from './useStandaloneMode';
import styles from './InstallPromptManager.module.css';

export function InstallPromptManager() {
  const isStandalone = useStandaloneMode();
  const {
    canInstall,
    dismissInstallPrompt,
    isIOSInstallEligible,
    promptInstall,
  } = useInstallPrompt(isStandalone);
  const [showIOSInstructions, setShowIOSInstructions] = useState(false);

  if (canInstall) {
    return (
      <section
        aria-label="Install Kudu"
        aria-live="polite"
        className={styles.prompt}
      >
        <div className={styles.copy}>
          <p className={styles.title}>Install Kudu</p>
          <p className={styles.body}>Open homework faster from your device.</p>
        </div>
        <div className={styles.actions}>
          <Button onClick={dismissInstallPrompt} size="small" variant="ghost">
            Not now
          </Button>
          <Button
            onClick={() => {
              void promptInstall();
            }}
            size="small"
            variant="primary"
          >
            Install
          </Button>
        </div>
      </section>
    );
  }

  if (isIOSInstallEligible) {
    return (
      <>
        <section
          aria-label="Install Kudu on iOS"
          aria-live="polite"
          className={styles.prompt}
        >
          <div className={styles.copy}>
            <p className={styles.title}>Add Kudu to Home Screen</p>
            <p className={styles.body}>Get app-like access on this device.</p>
          </div>
          <div className={styles.actions}>
            <Button onClick={dismissInstallPrompt} size="small" variant="ghost">
              Not now
            </Button>
            <Button
              onClick={() => setShowIOSInstructions(true)}
              size="small"
              variant="primary"
            >
              Show steps
            </Button>
          </div>
        </section>
        <IOSInstallInstructions
          onOpenChange={(open) => {
            setShowIOSInstructions(open);
            if (!open) {
              dismissInstallPrompt();
            }
          }}
          open={showIOSInstructions}
        />
      </>
    );
  }

  return null;
}

